<template>
  <div class="hello">
    <h1>Hello AK Fellows!</h1>

    <a href="https://umd.zoom.us/j/5150865021">進入直播間 →</a>

    <div style="margin-bottom: 16px">{{ date }}</div>
    <div style="margin-bottom: 16px">
      還沒寫 doPost，也不打算寫了...<br />不如你直接進<a
        href="https://docs.google.com/spreadsheets/d/1MZtiaLBXLM4wEuv7a-J5Xqo5RhgF88_Bz8lMJ1VJ_QQ/edit#gid=0"
        >資料表</a
      >更新資料？
    </div>

    <div>
      <ul v-if="loading">
        <li>loding...</li>
      </ul>
      <div v-else>
        <div style="font-size: 24px">
          下次的議程時間 {{ allConf.date[length - 1] }}
        </div>
        <ul>
          <li class="block">{{ allConf.vincent[length - 1] }}｜ Vincent</li>
          <li class="block">{{ allConf.chris[length - 1] }} ｜ Chris</li>
          <li class="block">{{ allConf.jing[length - 1] }} ｜ Jing</li>
        </ul>

        <div>
          <span style="margin-right: 4px">回到過去</span>
          <span
            style="margin-right: 4px"
            :key="index"
            v-for="(item, index) in allConf['jing']"
          >
            <router-link :to="{ name: 'Conf', params: { confId: index + 1 } }">
              <strong>{{ index + 1 }}</strong>
            </router-link>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HelloWorld",
  // props: {
  //   msg: String,
  // },
  data() {
    return {
      date: "",
      allConf: {},
      param: 999,
      loading: true,
      length: 0,
    };
  },
  mounted() {
    this.date = new Date();

    this.param = this.$route.params.confId;
    // console.log("param", param);
    axios
      .get(
        "https://script.google.com/macros/s/AKfycbzsWcSBu05V1gYHhggaKCLT0h6n6zVjGTWh-l8KJPYSJcfo0yEVPukhb6bfTr6pHy2R/exec"
      )
      // .then((response) => (this.conf = response.data))
      .then((response) => {
        console.log(response);
        this.allConf = response.data;
        console.log(response.data);
        this.length = response.data["jing"].length;
        this.loading = false;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.block {
  display: block;
}

.page-border {
  margin-right: 2px;
}
</style>
